import { createAction } from '@reduxjs/toolkit';

export const reviewUpdateId = createAction('review/updateId');
export const reviewUpdateUID = createAction('review/updateUid');
export const reviewUpdateSID = createAction('review/updateSid');
export const reviewUpdateIsAdded = createAction('review/updateIsAdded');
export const reviewUpdateIsActive = createAction('review/updateIsActive');

export const reviewStore = createAction('review/store');
export const reviewClear = createAction('review/clear');

export const reviewUpdateRequesting = createAction('review/updateRequesting');
export const reviewUpdateRequest = createAction('review/updateRequest');
export const reviewUpdateError = createAction('review/updateError');
export const reviewUpdateStore = createAction('review/updateStore');

export const reviewUpdateItems = createAction('review/updateItems');
export const reviewUpdateBackgroundColor = createAction('review/updateBackgroundColor');
export const reviewUpdateTextColor = createAction('review/updateTextColor');
export const reviewUpdateLayout = createAction('review/updateLayout');

export const reviewUpdateHeadingTitle = createAction('review/updateHeadingTitle');
export const reviewUpdateHeadingDescription = createAction('review/updateHeadingDescription');
export const reviewUpdateHeadingTextAlign = createAction('review/updateHeadingTextAlign');
export const reviewUpdateHeadingImage = createAction('review/updateHeadingImage');
export const reviewUpdateHeadingDivider = createAction('review/updateHeadingDivider');

export const reviewUpdateSectionIsBackground = createAction('review/updateSectionIsBackground');
export const reviewUpdateSectionTextColor = createAction('review/updateSectionTextColor');
export const reviewUpdateSectionBackgroundColor = createAction('review/updateSectionBackgroundColor');
export const reviewUpdateSectionOpacity = createAction('review/updateSectionOpacity');
export const reviewUpdateSectionIsFullWidth = createAction('review/updateSectionIsFullWidth');
export const reviewUpdateSectionShadow = createAction('review/updateSectionShadow');
export const reviewUpdateSectionShadowColor = createAction('review/updateSectionShadowColor');
export const reviewUpdateSectionPadding = createAction('review/updateSectionPadding');
export const reviewUpdateSectionMargin = createAction('review/updateSectionMargin');
export const reviewUpdateSectionBackgroundType = createAction('review/updateSectionBackgroundType');
export const reviewUpdateSectionBackgroundImage = createAction('review/updateSectionBackgroundImage');
export const reviewUpdateSectionGradientColor1 = createAction('review/updateSectionGradientColor1');
export const reviewUpdateSectionGradientColor2 = createAction('review/updateSectionGradientColor2');
export const reviewUpdateSectionGradientDirection = createAction('review/updateSectionGradientDirection');
export const reviewUpdateSectionGradientOffset = createAction('review/updateSectionGradientOffset');
export const reviewUpdateSectionBorder = createAction('review/updateSectionBorder');
export const reviewUpdateSectionBorderColor = createAction('review/updateSectionBorderColor');
export const reviewUpdateSectionShadowBorderColor = createAction('review/updateSectionShadowBorderColor');
export const reviewUpdateSectionShape = createAction('review/updateSectionShape');

export const reviewUpdateItemShadow = createAction('review/updateItemShadow');
export const reviewUpdateItemShadowColor = createAction('review/updateItemShadowColor');
export const reviewUpdateItemBorder = createAction('review/updateItemBorder');
export const reviewUpdateItemBorderColor = createAction('review/updateItemBorderColor');
export const reviewUpdateItemShape = createAction('review/updateItemShape');
